export function getRelativeCoordinates(elBoundaries) {
  const x = elBoundaries.left
  const y = elBoundaries.top

  return { x, y }
}

export function shiftByPageOffset({ x, y }) {
  const { pageXOffset, pageYOffset } = window

  return {
    x: x + pageXOffset,
    y: y + pageYOffset,
  }
}

export function shiftByCenter(tooltipBoundaries, elBoundaries, { x, y }) {
  return {
    x: x - Math.round(tooltipBoundaries.width / 2) + Math.round(elBoundaries.width / 2),
    y,
  }
}

export function shiftUp(tooltipBoundaries, { x, y }) {
  return {
    x,
    y: y - tooltipBoundaries.height,
  }
}

export function shiftUnder(elBoundaries, { x, y }) {
  return {
    x,
    y: y + elBoundaries.height,
  }
}
